import { EditCoursePageLayout } from '@hendrx/core/courses';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/courses/edit/$courseDraftId')({
  component: EditCourseLayout
});

function EditCourseLayout() {
  const { courseDraftId } = Route.useParams();

  return (
    <EditCoursePageLayout courseDraftId={courseDraftId}>
      <Outlet />
    </EditCoursePageLayout>
  );
}
